<template>
  <div v-if="this.whitelabel.brand === 'quickwill'">
    <v-container fluid class="mt-3 pa-0">
      <v-row class="mb-5 text-center" no-gutters>
        <v-col cols="12" md="8" offset-md="2" class="text-center">
          <h1 class="mt-5">Oops! We can't find that webpage</h1>
          <v-img
            :src="require(`@/assets/${whitelabel.images.pageNotFound}`)"
            aspect-ratio="1"
            alt="cute dog"
            class="not-found-image mt-3"
          />
          <v-btn class="mt-12" color="secondary" to="/" rounded depressed large
            >Go to homepage</v-btn
          >
          <v-btn
            class="mt-12"
            color="primary"
            to="/signup"
            rounded
            depressed
            large
            >Log in</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
  <div v-else>
    <Layout :containers="containers">
      <template v-slot:page-not-found>
        <v-container fluid>
          <div
            class="page-not-found-container d-flex align-center justify-center"
          >
            <div class="d-flex flex-column align-center">
              <v-img
                :src="require(`@/assets/shared/404.svg`)"
                alt="404 Not Found"
                class="page-not-found-image"
              />
              <p class="oops">Oops! This is awkward</p>
              <p class="cant-find">
                We can't seem to find the page you are looking for.
              </p>
              <div class="button-container">
                <GradientButton
                  :title="'GO TO HOMEPAGE'"
                  :callout="'right'"
                  @gradientButtonClicked="homepage"
                />
              </div>
            </div>
          </div>
        </v-container>
      </template>
    </Layout>
  </div>
</template>
<script>
import Layout from "../common/layouts/Layout.vue";
export default {
  name: "PageNotFound",
  components: {
    Layout,
  },
  data() {
    return {};
  },
  computed: {
    containers() {
      return [
        {
          name: "page-not-found",
          background: "countryPattern",
          fadedRow: true,
          class: "page-not-found",
        },
      ];
    },
  },
  methods: {
    homepage() {
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss" scoped>
.not-found-image {
  max-width: 300px;
}

.page-not-found-container {
  padding-top: 11dvh;
}
.page-not-found-image {
  max-width: 328px;
}

.oops {
  margin: 24px;
  font-size: 22px;
  font-weight: 500;
  line-height: 26px;
  text-align: center;
  color: black;
}
.cant-find {
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  text-align: center;
  color: black;
}
@media screen and (min-width: 0px) and (max-width: 430px) {
  .page-not-found-image {
    max-width: 218px;
  }
  .page-not-found-container {
    padding-top: 25dvh;
  }
}
</style>
